import { render, staticRenderFns } from "./CourseContractsForm.vue?vue&type=template&id=76e48a48&"
import script from "./CourseContractsForm.vue?vue&type=script&lang=js&"
export * from "./CourseContractsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports